var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scaler",staticClass:"scaler",style:(_vm.style)},[_vm._t("default"),_c('dynamic-style',{attrs:{"value":_vm.deepStyle}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }